module.exports = __webpack_public_path__ + "static/img/alert.f1743f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/alert.png
// module id = 1028
// module chunks = 0